import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { paragraphSmall } from '@helpers/typography';
import HeaderStyles from '@stories/Widgets/Header/Header.styles';
import styled from 'styled-components';
const Container = styled.section `
  position: absolute;
  top: 100%;
  left: -16px;
  display: block;
  height: auto;
  pointer-events: none;
  visibility: hidden;
  width: auto;

  [data-active='true'] & {
    pointer-events: all;
    visibility: visible;
  }

  ${HeaderStyles.Container}[data-reduce="true"] & {
    display: none;
  }
`;
const List = styled.ul `
  display: block;
`;
const Item = styled.li `
  display: block;
`;
const Link = styled.a `
  ${paragraphSmall}
  display: block;
  background: ${brand.beige};
  color: ${brand.black};
  ${fonts.brandonGrotesque.medium}
  margin: 0;
  padding: 8px 16px;
  text-decoration: none;
  ${transition('background-color, color')};
  white-space: nowrap;

  &:focus,
  &:hover {
    background: ${brand.green};
    color: ${brand.white};
  }
`;
const NavigationSimpleMenuStyles = {
    Container,
    Item,
    Link,
    List,
};
export default NavigationSimpleMenuStyles;
